import { MdLogout } from "react-icons/md";
import { useTranslation } from "react-i18next";

const LogoutButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-[14px] px-[16px] py-[13px] text-[15px] font-[400] text-[#C73F21]"
    >
      <MdLogout size={20} />
      <span>{t("navDrawer.logOut")}</span>
    </button>
  );
};

export default LogoutButton;
